import { useEffect, useState } from "react";
import { useTheme } from "../../../../components/hooks/useTheme";
import colorConfigs from "../../../../configs/colorConfigs";
import { BlockedPeriodsList } from "./BlockedPeriodsList";
import { AddBlockedPeriod } from "./AddBlockedPeriod";

const filterItems = [
    {
        id: 0,
        label: "Description",
    },
]

type BlockedPeriodProps = {
    idNumber: any
}

export const BlockedPeriods = ({
    idNumber
}: BlockedPeriodProps) => {
    const { themeStyles } = useTheme();
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 10,
    });
    const [searchValue, setSearchValue] = useState<string>("");
    const [blockedPeriodFilterValue, setBlockedPeriodFilterValue] = useState(0);
    const [selectedFilter, setSelectedFilter] = useState<string>(filterItems[0].label);
    const [openAddBlockedPeriod, setOpenAddBlockedPeriod] = useState<boolean>(false);
    const [refreshBlockedPeriodList, setRefreshBlockedPeriodList] = useState<boolean>(false);

    useEffect(() => {
        if (refreshBlockedPeriodList) {
            setPaginationModel({
                page: 0,
                pageSize: 10,
            })
            setSearchValue("");
            setRefreshBlockedPeriodList(false);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [refreshBlockedPeriodList])

    return (
        <>
            <div className={`px-[24px] py-[20px] min-h-screen h-full`}>

                <div className="flex items-center justify-end">
                    <div className="flex items-center gap-2.5">
                        <button className={`px-[8px] py-[6px] ${colorConfigs.btn.main.tailwind} rounded-lg border ${themeStyles.main.borderColor} text-white flex items-center gap-1.5`}
                            onClick={() => setOpenAddBlockedPeriod(true)}
                        >
                            <span className="material-symbols-outlined text-[25px] font-light">
                                add
                            </span>
                            <span className="text-xs font-medium">Blocked Period</span>
                        </button>
                    </div>
                </div>
                <div>
                    <BlockedPeriodsList
                        paginationModel={paginationModel}
                        setPaginationModel={setPaginationModel}
                        searchValue={searchValue}
                        setSearchValue={setSearchValue}
                        blockedPeriodFilterValue={blockedPeriodFilterValue}
                        setBlockedPeriodFilterValue={setBlockedPeriodFilterValue}
                        selectedFilter={selectedFilter}
                        setSelectedFilter={setSelectedFilter}
                        filterItems={filterItems}
                        idNumber={idNumber}
                        setRefreshBlockedPeriodList={setRefreshBlockedPeriodList}
                    />
                </div>
            </div>
            {
                openAddBlockedPeriod && (
                    <AddBlockedPeriod
                        idNumber={idNumber}
                        openAddBlockedPeriod={openAddBlockedPeriod}
                        setOpenAddBlockedPeriod={setOpenAddBlockedPeriod}
                        setRefreshBlockedPeriodList={setRefreshBlockedPeriodList}
                    />
                )
            }
        </>

    )
}